export default "__VITE_ASSET__COu4SEwn__"